<template>
  <div>
    <CookieControl :locale="locale">
      <template #bar>
        <p id="title">{{ t('cookiePolicy') }}</p>
        <p>
          {{ t('cookiePolicyText') }}
          <a class="cursor-pointer" @click="changeRoute('account-privacy-policy')">{{ t('privacyPolicy') }}</a>
          .
        </p>
      </template>
    </CookieControl>
  </div>
</template>
<script setup lang="ts">
  import { checkEnabledCookies } from '~/composables/navigation'

  const { t, locale } = useI18n()
  const { cookiesEnabledIds } = useCookieControl()

  watch(
    () => cookiesEnabledIds.value,
    () => {
      checkEnabledCookies()
    },
    { deep: true }
  )
</script>
<i18n>
{
  "pt": {
    "cookiePolicy": "Política de Cookies",
    "cookiePolicyText": "A miio Store utiliza cookies para que tenha uma experiência de compra otimizada. Os cookies permitem ao nosso site reconhecer utilizadores recorrentes, facilitando assim a personalização do conteúdo e a análise de tráfego. Esta prática está em conformidade com a nossa"
  },
  "en": {
    "cookiePolicy": "Cookie Policy",
    "cookiePolicyText": "Miio Store uses cookies to ensure you have an optimized shopping experience. Cookies allow our site to recognize returning users, making it easier to personalize content and analyze traffic. This practice is in accordance with our"
  },
  "es": {
    "cookiePolicy": "Política de Cookies",
    "cookiePolicyText": "Miio Store utiliza cookies para garantizar que tenga una experiencia de compra optimizada. Las cookies permiten que nuestro sitio reconozca a los usuarios que regresan, facilitando así la personalización del contenido y el análisis del tráfico. Esta práctica está en conformidad con nuestra"
  },
  "fr": {
    "cookiePolicy": "Politique de Cookies",
    "cookiePolicyText": "Miio Store utilise des cookies pour garantir que vous avez une expérience d'achat optimisée. Les cookies permettent à notre site de reconnaître les utilisateurs réguliers, facilitant ainsi la personnalisation du contenu et l'analyse du trafic. Cette pratique est conforme à notre"
  }
}
</i18n>
<style>
  .cookieControl__Bar {
    font-family: 'Source Sans Pro', sans-serif !important;
  }

  .cookieControl__BarContainer {
    max-width: 80rem;
    margin: 0 auto;
    padding: 2rem !important;
  }

  .cookieControl__Bar--bottom-full {
    box-shadow: 0 4px 22px 0 rgba(0, 0, 0, 0.08);
  }

  .cookieControl__BarContainer #title {
    color: #282c30 !important;
    font-weight: 700;
    font-size: 1.2rem;
  }

  .cookieControl__BarContainer p {
    color: #575757 !important;
  }

  .cookieControl__BarContainer p a {
    color: #318c88 !important;
  }

  .cookieControl__BarButtons {
    margin-left: 2rem;
    align-items: center;
    height: 6rem;
  }

  .cookieControl__BarButtons button,
  .cookieControl__ModalButtons button {
    padding: 0.3rem !important;
    font-weight: 600;
    min-width: 8rem;
  }

  .cookieControl__BarButtons:focus {
    outline: none;
    margin: 0;
  }

  .cookieControl__BarButtons button:nth-child(1),
  .cookieControl__BarButtons button:nth-child(1):hover,
  .cookieControl__ModalButtons button:nth-child(1),
  .cookieControl__ModalButtons button:nth-child(1):hover {
    background-color: #318c88;
    border: 2px solid #318c88;
    color: white;
    border-radius: 0.5rem;
  }

  .cookieControl__BarButtons button:nth-child(2),
  .cookieControl__BarButtons button:nth-child(2):hover,
  .cookieControl__ModalButtons button:nth-child(2),
  .cookieControl__ModalButtons button:nth-child(2):hover {
    background-color: white;
    border: 2px solid #318c88;
    color: #318c88;
    border-radius: 0.5rem;
  }

  .cookieControl__BarButtons button:nth-child(3),
  .cookieControl__BarButtons button:nth-child(3):hover,
  .cookieControl__ModalButtons button:nth-child(3),
  .cookieControl__ModalButtons button:nth-child(3):hover {
    background-color: white;
    color: #318c88;
    font-weight: 600;
  }

  .cookieControl__ModalContent {
    border-radius: 1.2rem;
    overflow-y: auto !important;
    max-width: 650px !important;
  }

  .cookieControl__ModalClose {
    color: white !important;
    background: white !important;
    font-size: 0 !important;
    padding: 0 !important;
  }

  .cookieControl__ModalClose:after {
    content: '✕';
    font-size: 1.5rem;
    color: #575757;
    display: inline-block;
    vertical-align: middle;
    width: 100%;
  }

  .cookieControl__ModalContentInner h2 {
    color: #282c30 !important;
    font-weight: 600;
    margin-bottom: 0.5rem !important;
  }

  .cookieControl__ModalContent input:checked:disabled + button,
  .cookieControl__ModalContent input:checked + button {
    background-color: #e1efef !important;
  }
  .cookieControl__ModalContent input:checked:disabled + button:before {
    background-color: #a8cac9 !important;
  }

  .cookieControl__ModalContent input + button {
    background-color: #dddddd !important;
  }

  .cookieControl__ModalContent input:checked + button:before {
    background-color: #318c88 !important;
  }

  .cookieControl__ModalContent input + button:before {
    background-color: #868686 !important;
  }

  .cookieControl button:focus {
    border: 0 !important;
    outline: none !important;
    box-shadow: 0 0 0 0 !important;
  }

  .cookieControl__ModalButtons {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
  }

  .cookieControl {
    background-color: #282c30 !important;
    height: 100% !important;
    width: 100% !important;
  }
</style>
